/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Demo_Text_ExcerptInputs */

const en_mcp_demo_text_excerpt = /** @type {(inputs: Mcp_Demo_Text_ExcerptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q3 planning notes: ship the reader redesign first, then onboarding. Three open questions for Thursday's review.`)
};

const es_mcp_demo_text_excerpt = /** @type {(inputs: Mcp_Demo_Text_ExcerptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas de planificación del T3: primero el rediseño del lector, luego el onboarding. Tres preguntas abiertas para la revisión del jueves.`)
};

/**
* | output |
* | --- |
* | "Q3 planning notes: ship the reader redesign first, then onboarding. Three open questions for Thursday's review." |
*
* @param {Mcp_Demo_Text_ExcerptInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_demo_text_excerpt = /** @type {((inputs?: Mcp_Demo_Text_ExcerptInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Demo_Text_ExcerptInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_demo_text_excerpt(inputs)
	return en_mcp_demo_text_excerpt(inputs)
});